import { BooleanButtonsInput, BooleanField, BooleanFieldInputProps, TextField } from "@hex-insights/forms";
import { MedicationFormValues } from "../../FormUtilities";
import { BaseFieldProps } from "../shared";

/**
 * Generic props for fields of the Medication model.
 */
type FieldProps<K extends keyof MedicationFormValues.Base = keyof MedicationFormValues.Base> = BaseFieldProps<
	Pick<MedicationFormValues.Base, K>
>;

/**
 * Field component for the `name` field of the Medication model.
 */
export function Name({ formState, ...props }: FieldProps<"name">) {
	return <TextField formState={formState} name="name" {...props} />;
}

/**
 * Field component for the `isPrescription` field of the Medication model.
 */
export function IsPrescription({ formState, label = "Medication Type", ...props }: FieldProps<"isPrescription">) {
	return (
		<BooleanField
			formState={formState}
			name="isPrescription"
			label={label}
			Input={IsPrescriptionInput}
			oneLine={false}
			{...props}
		/>
	);
}

function IsPrescriptionInput(props: BooleanFieldInputProps) {
	return <BooleanButtonsInput {...props} trueLabel="Prescription" falseLabel="Over the Counter" />;
}

/**
 * Field component for the `description` field of the Medication model.
 */
export function Description({ formState, ...props }: FieldProps<"description">) {
	return <TextField formState={formState} name="description" multiLine optional {...props} />;
}
